import React, { useMemo } from "react";
import {
  PROFILE_FAV_CRICKETER_OPTIONS,
  cricketerLogoUrl,
  type ProfileFavCricketerSlug,
} from "./profileFavCricketers";

type Props = {
  selected: readonly string[];
  onToggle: (slug: ProfileFavCricketerSlug) => void;
};

export function ProfileFavouriteCricketersGrid({ selected, onToggle }: Props) {
  const selectedSet = useMemo(() => new Set(selected), [selected]);

  return (
    <div className="w-full min-w-0 pb-5 sm:pb-7">
      <div className="pt-3 pb-5 sm:pt-4 sm:pb-6">
        <p className="text-center font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none]">
          Favourite Cricket players
        </p>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:gap-2.5">
        {PROFILE_FAV_CRICKETER_OPTIONS.map(({ slug, label }) => {
          const isSelected = selectedSet.has(slug);
          return (
            <button
              key={slug}
              type="button"
              onClick={() => onToggle(slug)}
              aria-pressed={isSelected}
              aria-label={label}
              className={`flex h-[32px] min-h-[32px] max-h-[32px] w-full min-w-0 flex-row items-center overflow-hidden rounded-none border-[3px] transition-colors box-border ${
                isSelected
                  ? "border-[#D2FF00] bg-[#8255BE]"
                  : "border-transparent bg-white/10 hover:bg-white/[0.14]"
              }`}
            >
              <img
                src={cricketerLogoUrl(slug)}
                alt=""
                width={24}
                height={24}
                className="h-[24px] w-[24px] shrink-0 object-cover"
                loading="lazy"
                decoding="async"
              />
              <span
                className={`flex min-w-0 flex-1 items-center truncate px-1.5 text-left font-anton text-[12px] font-normal uppercase leading-[16px] tracking-normal not-italic [leading-trim:none] sm:px-2 ${
                  isSelected ? "text-[#D2FF00]" : "text-white"
                }`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
